import React, { useEffect, useState } from 'react'
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import {
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Link,
  Button,
  FormHelperText,
  InputBase,
} from "@mui/material";
import { Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Head from "next/head";
import styles from "./Contact-us.module.css"
import MysteryBannerNew from '../MysteryBannerNew/MysteryBannerNew';

function ContactUs() {

const [user, setUser] = useState({});
const [error, setError] = useState({});
const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false);
const [open, setOpen] = React.useState(false);

const handleInput = (e) => {
  let name = e.target.name;
  let value = e.target.value;
  if (name === "state") {
    setError({ ...error, [name]: undefined });
  }

  setUser({ ...user, [name]: value });
};

// <--------------------------- Phone Formating --------------------------->
const phoneFormatting = (event) => {
  // console.log("event", event)
  if (event.target.value.split("").length <= 14) {
    let formatted = formatPhoneText(event.target.value);
    let name = event.target.name;
    user.phone = formatted;
    setUser({ ...user, [name]: formatted });
  }
};

function formatPhoneText(value) {
  value = value.trim().replaceAll("-", "");
  value = value.trim().replaceAll("(", "");
  value = value.trim().replaceAll(")", "");
  value = value.trim().replaceAll(" ", "");

  if (value.length > 3 && value.length <= 6)
    value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3);
  else if (value.length > 6)
    value =
      "(" +
      value.slice(0, 3) +
      ")" +
      " " +
      value.slice(3, 6) +
      "-" +
      value.slice(6);
  return value;
}



useEffect(() => {
  console.log(user);
}, [user]);
const handleSubmit = async (e) => {
  e.preventDefault();
  let errorObject = {};

  if (!user?.first_name) {
    errorObject.first_name = "First Name is Required";
  }
  if (!user?.email) {
    errorObject.email = "Email is Required";
  } else if (!/\S+@\S+\.\S+/.test(user.email)) {
    errorObject.email = "* Invalid email format";
  }
  if (!user?.last_name) {
    errorObject.last_name = "Last Name is Required";
  }
  if (!user?.city) {
    errorObject.city = "City is Required";
  }
  if (!user?.contact_number) {
    errorObject.contact_number = " Telephone Number is Required";
  }

  if (!user?.state) {
    errorObject.state = "State is Required";
  }
  if (!user?.comments) {
    errorObject.comments = "Questions Or Comments is Required";
  }

  if (Object.keys(errorObject).length > 0) {
    setError(errorObject);
    console.log("error exeist");
  } else {
    setUser({
      ...user,
      ["contact_number"]: user.contact_number.replace(/^\((.+)\)$/, ""),
    });
    setLoader(true);

    setError({});
    let requestOptions = {
      method: "POST",
      // mode:'no-cors',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(user),
    };
    console.log(user);
    try {
      let req = await fetch(
        "https://u7yxpmocqi.execute-api.us-west-1.amazonaws.com/dev/contact/practicelab-contact-add ",
        requestOptions
      );
      console.log("req", req);
      let res = await req.json();
      setSnackbarStare(true);
    } catch (error) {
      console.log(error, "this is submit error");
      setLoader(false);
    }
    setLoader(false);
    setUser(null);
    console.log("kjhkjh", user);
  }
};

const StateArray = [
  {
    name: "Alabama",
    val: "AL",
  },
  {
    name: "Alaska",
    val: "AK",
  },
  {
    name: "Arizona",
    val: "AZ",
  },
  {
    name: "Arkansas",
    val: "AR",
  },
  {
    name: "California",
    val: "CA",
  },
  {
    name: "Colorado",
    val: "CO",
  },
  {
    name: "Connecticut",
    val: "CT",
  },
  {
    name: "Delaware",
    val: "DE",
  },
  {
    name: "Florida",
    val: "FL",
  },
  {
    name: "Georgia",
    val: "GA",
  },
  {
    name: "Hawaii",
    val: "HI",
  },
  {
    name: "Idaho",
    val: "ID",
  },
  {
    name: "Illinois",
    val: "IL",
  },
  {
    name: "Indiana",
    val: "IN",
  },
  {
    name: "Iowa",
    val: "IA",
  },
  {
    name: "Kansas",
    val: "KS",
  },
  {
    name: "Kentucky",
    val: "KY",
  },
  {
    name: "Louisiana",
    val: "LA",
  },
  {
    name: "Maine",
    val: "ME",
  },
  {
    name: "Maryland",
    val: "MD",
  },
  {
    name: "Massachusetts",
    val: "MA",
  },
  {
    name: "Michigan",
    val: "MI",
  },
  {
    name: "Minnesota",
    val: "MN",
  },
  {
    name: "Mississippi",
    val: "MS",
  },
  {
    name: "Missouri",
    val: "MO",
  },
  {
    name: "Montana",
    val: "MT",
  },
  {
    name: "Nebraska",
    val: "NE",
  },
  {
    name: "Nevada",
    val: "NV",
  },
  {
    name: "New Hampshire",
    val: "NH",
  },
  {
    name: "New Jersey",
    val: "NJ",
  },
  {
    name: "New Mexico",
    val: "NM",
  },
  {
    name: "New York",
    val: "NY",
  },
  {
    name: "North Carolina",
    val: "NC",
  },
  {
    name: "North Dakota",
    val: "ND",
  },
  {
    name: "Ohio",
    val: "OH",
  },
  {
    name: "Oklahoma",
    val: "OK",
  },
  {
    name: "Oregon",
    val: "OR",
  },
  {
    name: "Pennsylvania",
    val: "PA",
  },
  {
    name: "Rhode Island",
    val: "RI",
  },
  {
    name: "South Carolina",
    val: "SC",
  },
  {
    name: "South Dakota",
    val: "SD",
  },
  {
    name: "Tennessee",
    val: "TN",
  },
  {
    name: "Texas",
    val: "TX",
  },
  {
    name: "Utah",
    val: "UT",
  },
  {
    name: "Vermont",
    val: "VT",
  },
  {
    name: "Virgin Islands",
    val: "VI",
  },
  {
    name: "Virginia",
    val: "VA",
  },
  {
    name: "Washington",
    val: "WA",
  },
  {
    name: "West Virginia",
    val: "WV",
  },
  {
    name: "Wisconsin",
    val: "WI",
  },
  {
    name: "Wyoming",
    val: "WY",
  },
];
return (
  <>
    {/* <Head>
      <title>Contact School of Our Divine Infinite Being – Reach Us 24/7</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
      <meta name="keywords" content="School of Our Divine Infinite Being, 24/7 Customer Service, Contact Information."></meta>
      <meta name="description" content="Connect with the School of Our Divine Infinite Being for inquiries about courses, registration, or general questions. Reach out via email or phone, or fill out our contact form. Available 24/7 to assist you!"></meta>

      <meta property="og:title" content="Contact School of Our Divine Infinite Being – Reach Us Anytime"></meta>
      <meta property="og:type" content="website"></meta>
      <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/contact_us_og_img.webp"></meta>
      <meta property="og:image:alt" content="Contact-us"></meta>
      <meta property="og:description" content="Connect with the School of Our Divine Infinite Being for inquiries about courses, registration, or general questions. Reach out via email or phone, or fill out our contact form. Available 24/7 to assist you!"></meta>

      <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/contact_us_og_img.webp"></meta>
      <meta property="twitter:image:alt" content="Contact-us"></meta>
      <meta name="twitter:card" content="summary_large_image"></meta>
      <meta property="twitter:title" content="Contact School of Our Divine Infinite Being – Reach Us Anytime"></meta>
      <meta property="twitter:url" content="https://www.divineinfinitebeing.com/contact-us"></meta>
      <meta property="twitter:description" content="Connect with the School of Our Divine Infinite Being for inquiries about courses, registration, or general questions. Reach out via email or phone, or fill out our contact form. Available 24/7 to assist you!"></meta>

      <meta property="og:image:width" content="1200"></meta>
      <meta property="og:image:height" content="627"></meta>
      <meta property="og:url" content="https://www.divineinfinitebeing.com/contact-us"></meta>
    </Head> */}

    <div className="contact_us_wrapper">
      <div className={styles.nodatadashboard} id="body">
        <div className={styles.maincontentinnerpage} id="maincontent">

          <div className={styles.contactusblockone}>


            <div className={styles.asmainwrapper}>
              <div className={styles.contactusblockoneleft}>
                <span className={styles.bannerLogo}>
                  <span
                    className={styles.logoviewlink}
                    alt={styles.viewicon}
                    onClick={handleOpen}
                  >
                    <img
                      src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                    />
                  </span>
                  <img
                    src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                  />
                </span>
                <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE</h1>
                <h1 data-text="infinite being">infinite being</h1>
                <h2>
                  Polytheistic Monism - Divine Theurgy - Oracle to the Gods
                </h2>
                <div
                  className={styles.rotathewheelbottombannerbgbannerboxtxt}
                ></div>
              </div>
            </div>
          </div>

          <MysteryBannerNew/>

          <div className={styles.contactusblocktwo}>
            <div className={styles.common}>
              <div className={styles.countDivtitleblock}>
                <div className={styles.columns}>
                  <div className={styles.col12h}>
                    <h1>
                      Get in touch with School of Our Divine Infinite Being
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={`${styles.common} ${styles.common_sub}`}>
              <div className={styles.contactus_block2}>
                <div className={styles.flex}></div>
                <div className={styles.flex2}>
                  <div className={styles.block2_logoimg}>
                    <span className={styles.block2_bannerLogo}>
                      {/* <img
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                        alt="bannerLogo"
                      /> */}
                      <img
                        src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                      />
                    </span>
                    <span className={styles.block2_bannerleft}>
                      {/* <img
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/contactus/borderleft.png"
                        alt="bannerLogo"
                      /> */}
                      <img
                        src={`${process.env.cloud_url2}assets/images/contactus/borderleft.png`}
                      />
                      <h3>School of Our Divine Infinite Being</h3>
                      {/* <p>24/7 Customer Service</p> */}
                    </span>

                    <div className={styles.cu_block2_ep}>
                      <p>
                        <span>Email:</span>
                        <a href="mailto:beto@betoparedes.com" target="_top">
                          beto@betoparedes.com
                        </a>
                      </p>
                      <p>
                        <span>Phone:</span>
                        <a href="tel:208.440.7609" target="_top">
                          208.440.7609
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className={styles.cu_block2_form}>
                    {/* <div className={`${styles.homeblocktwo} ${styles.homeblockb4two}`}> */}

                    <h1>Contact Us</h1>
                    <form>
                      <TextField
                        className={`${styles.from_input} ${styles.form_field_wrapperfname}`}
                        id="outlined-basic"
                        name="first_name"
                        value={user?.first_name ? user.first_name : ""}
                        onChange={handleInput}
                        error={error.first_name ? true : false}
                        helperText={error.first_name}
                        onKeyDown={() => {
                          error.first_name = "";
                        }}
                        // label="Email*"
                        variant="outlined"
                        label="First Name"
                      />
                      <TextField
                        className={`${styles.from_input} ${styles.form_field_wrapperlname}`}
                        id="outlined-basic"
                        name="last_name"
                        value={user?.last_name ? user.last_name : ""}
                        onChange={handleInput}
                        error={error?.last_name ? true : false}
                        helperText={error.last_name}
                        onKeyDown={() => {
                          error.last_name = "";
                        }}
                        // label="Email*"
                        variant="outlined"
                        label="Last Name"
                      />
                      <div
                        className={`${styles.cs_formtext} ${styles.form_field_wrapperemail}`}
                      >
                        <TextField
                          className={`${styles.from_input} `}
                          id="outlined-basic"
                          name="email"
                          value={user?.email ? user.email : ""}
                          onChange={handleInput}
                          error={error.email ? true : false}
                          helperText={error.email}
                          onKeyDown={() => {
                            error.email = "";
                          }}
                          // label="Email*"
                          variant="outlined"
                          label="Email"
                        />

                        <TextField
                          label="Phone Number:"
                          className={`${styles.from_input} `}
                          variant="outlined"
                          fullWidth={true}
                          name="contact_number"
                          type="text"
                          onKeyPress={(e) => {
                            error.contact_number = "";
                            // console.log("this is number onkeydown=====", e.code, e.key, 'e.which', e.which);
                            if (e.which < 48 || e.which > 57) {
                              e.preventDefault();
                            } else {
                              let input = e.target.value;
                              let result = input.replace(/\D/g, "");
                              console.log(input, result, "suyagudsa");
                            }
                          }}
                          onChange={(e) => phoneFormatting(e)}
                          value={user?.contact_number}
                          error={error?.contact_number ? true : false}
                          helperText={error?.contact_number}
                        />
                      </div>
                      <TextField
                        id="outlined-multiline-flexible"
                        label="Massage"
                        name="comments"
                        className={`${styles.from_input} ${styles.form_field_wrappermessage}`}
                        value={user?.comments ? user.comments : ""}
                        onChange={handleInput}
                        error={error.comments ? true : false}
                        helperText={error.comments}
                        onKeyDown={() => {
                          error.comments = "";
                        }}
                        multiline
                        rows={3}
                        maxRows={4}
                      />

                      <FormControl
                        className={`${styles.from_input} ${styles.form_field_wrapperstate}`}
                      >
                        <InputLabel id="demo-simple-select-helper-label">
                          Select State
                        </InputLabel>
                        <Select
                          className="contact_select_menu"
                          id="demo-simple-select-helper"
                          label="Select State"
                          name="state"
                          onChange={handleInput}
                          value={user?.state ? user.state : ""}
                          error={error.state ? true : false}
                          // value={user.select_taxonomy}
                          // onChange={handleInput}
                          // helperText={error.select_taxonomy}
                        >
                          {StateArray.map((item, key) => {
                            return (
                              <MenuItem
                                className="contact_menu_item"
                                value={item.val}
                                key={key}
                              >
                                {item.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {error.state && (
                          <FormHelperText
                            id="my-helper-text"
                            style={{ color: "red" }}
                          >
                            {error.state}
                          </FormHelperText>
                        )}
                      </FormControl>
                      <Button
                        className={`${styles.button} ${styles.submitbtnsection}`}
                        variant="contained"
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                    </form>
                    {/* <h3>Connect with us</h3>
                    <div className={styles.social_list}>
                      <div className={styles.social_list_div2}>
                        <Link
                          href="https://www.facebook.com/TranscendentPagan"
                          target="_blank"
                        >
                          <img
                            src={`${process.env.cloud_url2}assets/images/contactus/facebook.png`}
                          />
                        </Link>
                      </div>
                    </div> */}
                  </div>
                </div>
                {/* <div className={styles.cu_form2}>
              <TextField
                className={styles.from_input}
                id="outlined-basic"
                name="email"
                // label="Email*"
                variant="outlined"
                label="Practice Name*"
              />
            </div> */}
              </div>
            </div>
            <div className={styles.contactus_block2_girlimg}>
              {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/new-images/contactusblocktwoblock1bg_new.webp" /> */}
              <img
                src={`${process.env.cloud_url2}assets/new-images/contactusblocktwoblock1bg_new.webp`}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
    {/* ==================== modal =================== */}
    {/* <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="banner_modal_main"
    >
      <Box className="banner_modal_box">
        <Typography
          id="modal-modal-description"
          sx={{ mt: 2 }}
          className="modal_banner"
        >
          <div className="sub_modal_banner">
            <span className="close_btn" onClick={handleClose}>
              X
            </span>
            <img
              src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
              alt="bannerLogo"
            />
          </div>
        </Typography>
      </Box>
    </Modal> */}
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="banner_modal_main"
    >
      <Box className="banner_modal_box">
        <Typography
          id="modal-modal-description" component="div"
          sx={{ mt: 2 }}
          className="modal_banner"
        >
          <div className="sub_modal_banner">
            <span className="close_btn" onClick={handleClose}>
              <CloseIcon />
            </span>
            <img
              src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
              alt="bannerLogo"
            />
          </div>
        </Typography>
      </Box>
    </Modal>
  </>
);
}

export default ContactUs
